import { useTranslator } from '@bluebeam/react-i18n';
import ProviderFileBrowser from 'components/FileBrowser/ProviderFileBrowser';
import Navigation from 'components/Navigation';
import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { ConnectedAccount } from 'records/ConnectedAccount';
import * as toast from 'utils/toast';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends RouteComponentProps, WithAppStoreProps {}

const IntegrationsFileBrowserPage: React.FC<Props> = (props: Props) => {
  const { actions, appState, history } = props;
  const { translate } = useTranslator([
    'integrationsFileBrowserPage',
    'buttons',
    'toastText',
  ]);
  const connectedAccount =
    appState.getSelectedConnectedAccount() || new ConnectedAccount();

  const confirmFileSelection = async () => {
    await actions.importDrawingsFromDms();
    history.push(`/project/${appState.selectedProject}/drawings/uploads`);
    toast.success(
      translate('toastText:filePendingUpload.message'),
      `${connectedAccount.providerType.toLocaleUpperCase()}: ${translate(
        'toastText:filePendingUpload.title'
      )}`
    );
    window.setTimeout(actions.getProcessingStatuses, 1000);
  };

  const handleCancelClick = async (): Promise<void> => {
    await actions.resetIntegrationsView();
    await actions.resetIntegrationsSelectedItems();
    history.push(`/project/${appState.selectedProject}/drawings/published`);
  };

  useEffect(() => {
    if (!connectedAccount.providerType) {
      history.push(`/project/${appState.selectedProject}/drawings/published`);
    }
  }, []);

  return (
    <Navigation>
      <div id="integrations-upload" className="oh h100">
        <div className="px4 pt4 h100">
          <div className="row justify-between items-center pb4 bb-3">
            <div className="bold font-size-5">
              {translate('integrationsFileBrowserPage:itemsSelected', {
                count: appState.integrationsSelectedItems.count(),
              })}
            </div>
            <div className="row justify-between items-center">
              <button
                id="integrations-modal-sync-btn"
                className="row items-center btn-sm btn-link mr3"
                onClick={handleCancelClick}
              >
                {translate('buttons:cancel')}
              </button>
              <button
                id="integrations-modal-sync-btn"
                data-analytics="integrations-confirm-drawings-selection-button"
                className="row items-center btn-sm btn-primary mr3"
                onClick={confirmFileSelection}
                disabled={appState.integrationsSelectedItems.count() === 0}
              >
                {translate('buttons:confirmSelection')}
              </button>
            </div>
          </div>
          <div className="oh" style={{ height: 'calc(100% - 90px)' }}>
            <ProviderFileBrowser
              providerType={connectedAccount.providerType}
              connectionId={connectedAccount.id}
              onlyPdfFiles
            />
          </div>
        </div>
      </div>
    </Navigation>
  );
};

export default withAppStore<WithAppStoreProps>(IntegrationsFileBrowserPage);
